import styled from "styled-components";
export const PopoverElementBacker = styled.div.attrs(() => ({
    className: "bcr-popover-element",
})) `
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  position: absolute;
  z-index: -1;
`;
//# sourceMappingURL=GenericPopoverStyles.js.map